// extracted by mini-css-extract-plugin
export default {"label":"YearsInHomeSlider_label__HR1FN"};